'use strict';

// Set data to local storage by key with value
const setLocalStorage = (key: string, value: string) => {
    localStorage.setItem(key, value);
};

// get data from local stoage by key
const getLocalStorage = (key: string) => {
    return localStorage.getItem(key);
};

// Set data to session storage by key with value
const setSessionStorage = (key: string, value: string) => {
    sessionStorage.setItem(key, value);
};

// get data from session storage by key
const getSessionStorage = (key: string) => {
    return sessionStorage.getItem(key);
};

// remove data from session storage by key
const removeSessionStorage = (key: string) => {
    sessionStorage.removeItem(key);
};

export {
    setLocalStorage,
    getLocalStorage,
    setSessionStorage,
    getSessionStorage,
    removeSessionStorage
};
